'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'gamepad-modern';
var width = 576;
var height = 512;
var aliases = [127918,63676,"gamepad-alt"];
var unicode = 'e5a2';
var svgPathData = 'M576 156.7l0 323.3-165.8 0-1.8-5.5-30.2-90.5-180.4 0-30.2 90.5-1.8 5.5-165.8 0 0-323.3 124.7-124.7 326.6 0 124.7 124.7zM16 163.3l0 300.7 138.2 0 30.2-90.5 1.8-5.5 203.6 0 1.8 5.5 30.2 90.5 138.2 0 0-300.7-115.3-115.3-313.4 0-115.3 115.3zM168 216l48 0 0 16-48 0 0 48-16 0 0-48-48 0 0-16 48 0 0-48 16 0 0 48zm216 56a16 16 0 1 1 0-32 16 16 0 1 1 0 32zm48-80a16 16 0 1 1 0-32 16 16 0 1 1 0 32z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faGamepadModern = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;